import * as Icons from "lucide-react";
import { LessonCard } from "./LessonCard";

const TIER_META = {
  1: { t: "Foundations", b: "Start here — the core of this area." },
  2: { t: "Growth", b: "Build on the basics and go further." },
  3: { t: "Mastery", b: "Deepen the work and live it." },
};

export function LearningPath({ filtered, catById, onFav, onOpen }) {
  return (
    <div className="space-y-10" data-testid="lessons-grid">
      {[1, 2, 3].map((tier) => {
        const meta = TIER_META[tier];
        const size = Math.ceil(filtered.length / 3);
        const tierLessons = filtered.slice((tier - 1) * size, tier * size);
        if (tierLessons.length === 0) return null;
        const done = tierLessons.filter((l) => l.completed).length;
        const pct = Math.round((done / tierLessons.length) * 100);
        return (
          <div key={tier} data-testid={`learning-path-${tier}`}>
            <div className="flex items-center gap-4 mb-5">
              <div className="relative w-12 h-12 shrink-0">
                <svg viewBox="0 0 44 44" className="w-full h-full -rotate-90">
                  <circle cx="22" cy="22" r="20" fill="none" stroke="rgba(41,27,45,0.14)" strokeWidth="4.5" />
                  <circle cx="22" cy="22" r="20" fill="none" stroke="#C89B55" strokeWidth="4.5" strokeLinecap="round"
                    strokeDasharray={2 * Math.PI * 20} strokeDashoffset={(2 * Math.PI * 20) * (1 - pct / 100)} style={{ transition: "stroke-dashoffset .5s ease" }} />
                </svg>
                <div className="absolute inset-0 flex items-center justify-center font-heading text-lg">{tier}</div>
              </div>
              <div>
                <p className="text-[11px] uppercase tracking-[0.2em] text-[#291B2D] font-bold">Path {tier} · {meta.t}</p>
                <p className="text-sm text-[#291B2D]/70">{meta.b}</p>
                <p className="text-[11px] text-[#291B2D]/60 font-semibold mt-0.5" data-testid={`path-progress-${tier}`}>{done} of {tierLessons.length} done{pct === 100 ? " · path complete" : ""}</p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5">
              {tierLessons.map((l) => {
                const cat = catById[l.category_id];
                const Icon = Icons[cat?.icon] || Icons.Sparkles;
                return <LessonCard key={l.id} l={l} catName={cat?.title || ""} Icon={Icon} onFav={onFav} onOpen={onOpen} />;
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
